module.exports = __webpack_public_path__ + "static/media/attribute_card_uses.0b358017.png";